export const ensureMapContains = <Key, Item>(
  map: Map<Key, Item>,
  key: Key,
  defaultValue: () => Item,
): Item => {
  const item = map.get(key);
  if (item !== undefined) {
    return item;
  }

  const newItem = defaultValue();
  map.set(key, newItem);

  return newItem;
};
